/**
 * Content Type Badge Component
 * Displays a badge with an icon and label for different content types
 * Uses FontAwesome Pro icons matching the online-community implementation
 */

import '../../../../styles/oc-utilities.css';

import { Icon } from '@hl/ui-components';
import React from 'react';

import { ContentType, getIconForItemType } from '../../utils/itemTypeIcons';
import { Badge } from './ContentTypeBadge.styled';

export type { ContentType };

export type ContentTypeBadgeProps = {
  contentType: ContentType;
  customDisplay?: string;
  className?: string;
};

/**
 * ContentTypeBadge Component
 * Displays a small badge with an icon and text label
 * Uses FontAwesome Pro icons for consistency with the rest of the application
 */
const ContentTypeBadge: React.FC<ContentTypeBadgeProps> = ({ contentType, customDisplay, className = '' }) => {
  const { icon, color, display } = getIconForItemType(contentType, customDisplay);

  return (
    <Badge className={className}>
      <Icon icon={icon} style={{ color }} />
      <span>{display}</span>
    </Badge>
  );
};

export default React.memo(ContentTypeBadge);

